export default {
  GET_ALL: 'getAllProfileViews',
  SAVE_PROFILE_VIEW: 'saveProfileView',
  CREATE_PROFILE_VIEW_EXPORT: 'createProfileViewExport',
}